import type { WidgetComponent } from "@viz/presentation";

const PropertyGrid: WidgetComponent = ({ props }) => {
  const data = props.data as Record<string, { value: unknown; unit?: string; type?: string } | unknown> | undefined;
  if (!data) return <div className="px-4 py-3 text-sm text-slate-500">No properties.</div>;
  const rows = Object.entries(data);
  return (
    <table className="w-full text-sm">
      <tbody>
        {rows.map(([k, v]) => {
          const display = formatValue(v);
          const unit = (v && typeof v === "object" && "unit" in (v as Record<string, unknown>)) ? (v as { unit?: string }).unit : undefined;
          return (
            <tr key={k} className="border-b border-slate-200 last:border-b-0">
              <td className="w-1/3 py-2 pl-4 pr-2 text-slate-500">{k}</td>
              <td className="py-2 pr-4 font-mono text-slate-900 break-words">
                {display}{unit && <span className="ml-1 text-slate-500">{unit}</span>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

function formatValue(v: unknown): string {
  if (v == null) return "—";
  if (typeof v === "object" && "value" in (v as Record<string, unknown>)) {
    const inner = (v as { value: unknown }).value;
    return formatValue(inner);
  }
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

export default PropertyGrid;
